<script setup>
import { WdsButtonLink } from '@wds/components';
import propertyConfig from '@/config/property.js';

defineProps({
  tag: {
    type: String,
    required: false,
    default: 'section',
  },
  description: {
    type: String,
    required: true,
  },
});

// EVENTS
const emit = defineEmits(['viewMore']);

const { isBelowMediumScreen } = useMq();

const testingStore = useTestingStore();
const isReportButtonEnabled = testingStore.hasEnabledFeature('web_report_button_enabled');

const propertyDescriptionConfigs = propertyConfig.descriptionTruncateLength;

const descriptionLength = computed(() =>
  toValue(isBelowMediumScreen) ? propertyDescriptionConfigs.SHORT : propertyDescriptionConfigs.LONG,
);

function toggleAboutModal() {
  emit('viewMore', 'about');
}
</script>

<template>
  <component :is="tag">
    <h2 class="about-title">
      {{ $t('t_ABOUT') }}
    </h2>
    <div class="about-description">
      <div
        :class="{ 'line-clamp': descriptionLength }"
        :style="{ 'clamp-lines': descriptionLength, '-webkit-line-clamp': descriptionLength }"
      >
        <p
          class="text"
          v-html="description"
        />
      </div>
      <div class="about-actions">
        <CommonHwReportProperty v-if="isBelowMediumScreen && isReportButtonEnabled" />
        <WdsButtonLink
          :text="$t('t_READMORE')"
          class="about-read-more"
          icon-end="chevron-right"
          @click="toggleAboutModal()"
        />
      </div>
    </div>
  </component>
</template>

<style lang="scss" scoped>
.about-description {
  padding-bottom: $wds-spacing-s;

  .line-clamp {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;

    .text {
      @include body-2-reg;

      white-space: pre-line;
    }
  }

  .about-actions {
    display: flex;
    align-items: center;
    margin-top: $wds-spacing-m;
  }

  .about-read-more {
    cursor: pointer;
    margin-left: auto;
  }
}
</style>
